import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref,computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'InputComponent',
  props: {
    description: String
},
  emits: ['update:description'],
  setup(__props, { emit }) {

const props = __props




const over = ref<boolean>(false);

const descriptionComputed = computed({
  get: () => props.description,
  set: (value) => {
    if(value.length > 30){
      over.value=true;
    }else{
      over.value=false;
    }
    emit('update:description', value);
  },
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    placeholder: "tweet",
    type: "text",
    class: _normalizeClass(["input", [over.value ? 'over' : '']]),
    maxlength: "31",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(descriptionComputed) ? (descriptionComputed).value = $event : null))
  }, null, 2)), [
    [
      _vModelText,
      _unref(descriptionComputed),
      void 0,
      { trim: true }
    ]
  ])
}
}

})